import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { useCurrency } from "../context/CurrencyContext";

const FLAGS = { EUR: "🇪🇺", USD: "🇺🇸", GBP: "🇬🇧" };

const CurrencySelector = ({ compact = false }) => {
  const { currency, setCurrency, supported } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={ref} className="relative" data-testid="currency-selector">
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="currency-toggle"
        className={`flex items-center gap-1.5 label-caps tracking-[0.2em] text-[10px] text-white/70 hover:text-[color:var(--gold)] transition-colors ${compact ? "" : "border border-white/15 hover:border-[color:var(--gold)] px-3 py-1.5"}`}
      >
        <span>{FLAGS[currency]}</span>
        <span>{currency}</span>
        <ChevronDown size={12} strokeWidth={1.5} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 min-w-[120px] bg-[#0A0A0A] border border-white/15 z-50">
          {supported.map((c) => (
            <button
              key={c}
              data-testid={`currency-opt-${c}`}
              onClick={() => { setCurrency(c); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2 label-caps text-[10px] tracking-[0.2em] hover:bg-white/5 transition-colors ${currency === c ? "text-[color:var(--gold)]" : "text-white/70"}`}
            >
              <span>{FLAGS[c]}</span>
              <span>{c}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CurrencySelector;
